import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const Cursor = () => {
    const [enabled, setEnabled] = useState(false);
    const [hovering, setHovering] = useState(false);
    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const rx = useSpring(x, { stiffness: 260, damping: 24, mass: 0.5 });
    const ry = useSpring(y, { stiffness: 260, damping: 24, mass: 0.5 });

    useEffect(() => {
        const fine = window.matchMedia("(pointer: fine)").matches;
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (!fine || reduced) return undefined;
        setEnabled(true);
        const move = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
        };
        const over = (e) => {
            setHovering(!!e.target.closest("a, button, input, textarea, select, [data-cursor]"));
        };
        window.addEventListener("mousemove", move, { passive: true });
        window.addEventListener("mouseover", over, { passive: true });
        return () => {
            window.removeEventListener("mousemove", move);
            window.removeEventListener("mouseover", over);
        };
    }, [x, y]);

    if (!enabled) return null;

    return (
        <>
            <motion.div
                aria-hidden="true"
                className="pointer-events-none fixed left-0 top-0 z-[200] h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#0066FF]"
                style={{ x, y }}
            />
            <motion.div
                aria-hidden="true"
                className="pointer-events-none fixed left-0 top-0 z-[199] -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#0066FF]/50"
                style={{ x: rx, y: ry }}
                animate={{
                    width: hovering ? 52 : 34,
                    height: hovering ? 52 : 34,
                    opacity: hovering ? 0.9 : 0.5,
                }}
                transition={{ duration: 0.25 }}
            />
        </>
    );
};
